const GOOGLE_ADS_ID = 'AW-1034862903';
const PURCHASE_CONVERSION_ID = 'AW-1034862903/mBRqCLKYnL8cELeCu-0D';

type GoogleTagCommand = 'js' | 'config' | 'event';
type GoogleTagEventParameters = {
  send_to?: string;
  value?: number;
  currency?: string;
  transaction_id?: string;
  new_customer?: boolean;
};

declare global {
  interface Window {
    dataLayer?: unknown[][];
    gtag?: (command: GoogleTagCommand, ...args: unknown[]) => void;
  }
}

export function initializeGoogleAdsTag(): void {
  if (typeof window === 'undefined' || document.getElementById('gtag-src')) return;

  const script = document.createElement('script');
  script.id = 'gtag-src';
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GOOGLE_ADS_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  window.gtag = (command: GoogleTagCommand, ...args: unknown[]) => {
    window.dataLayer?.push([command, ...args]);
  };

  window.gtag('js', new Date());
  window.gtag('config', GOOGLE_ADS_ID);
}

export function trackGoogleAdsPurchase({
  transactionId,
  value,
  isNewCustomer
}: {
  transactionId: string;
  value: number;
  isNewCustomer: boolean;
}): void {
  if (typeof window === 'undefined' || !window.gtag || !transactionId) return;

  const eventParameters: GoogleTagEventParameters = {
    send_to: PURCHASE_CONVERSION_ID,
    value: Number(value.toFixed(2)),
    currency: 'USD',
    transaction_id: transactionId,
    new_customer: isNewCustomer
  };

  window.gtag('event', 'conversion', eventParameters);
}
